import { Component, signal } from '@angular/core';

import {
  DemoContextInfo,
  DemoContextInfoProgramSelected,
  DemoContextInfoProjectSelected,
} from '@demo/data/demo-context';
import { DemoContextService } from '@demo/system/context/demo-context.service';
import { ContextInfo, ContextService } from '@system/context';
import { ContextViewComponent } from '@system/context/view/context-view.component';

@Component({
  selector: 'app-demo-context',
  templateUrl: './demo-context.component.html',
  styleUrls: ['./demo-context.component.scss'],
  imports: [ContextViewComponent],
  providers: [{ provide: ContextService, useClass: DemoContextService }],
})
export class DemoContextComponent {
  context = signal<ContextInfo>(DemoContextInfo);
  contextProjectSelected = signal<ContextInfo>(DemoContextInfoProjectSelected);
  contextProgramSelected = signal<ContextInfo>(DemoContextInfoProgramSelected);
}
